import React from "react";
import graphic from "../../assets/images/DMA_Graphic.svg";
import Button from "../Button/Button";
import ScoreCharts from "../ScoreCharts";
import Text from "../Text/Text";
import styles from "./ScoreContainer.module.scss";

function ScoreContainer(props) {
  const { scores, handleModal, rankingText } = props;
  return (
    <Section>
      <Container>
        <Wrapper>
          <ScoreRank rankingText={rankingText} handleModal={handleModal} />
          <Graphic />
          <ScoreCharts scores={scores} />
        </Wrapper>
      </Container>
    </Section>
  );
}

/** Section to contain the scores */
function Section({ children }) {
  return <section className={styles.section}>{children}</section>;
}

/** Container to hold the wrapper for max-width */
function Container({ children }) {
  return <div className={styles.container}>{children}</div>;
}

/** Wrapper to contain graphic & scores */
function Wrapper({ children }) {
  return <div className={styles.wrapper}>{children}</div>;
}

/** DMA Graphic */
function Graphic() {
  return (
    <div className={styles.graphic_wrapper}>
      <img
        src={graphic}
        alt="Grant Thornton DMA Graphic"
        className={styles.graphic}
      />
      <Text variant="bodyLarge" weight="bold" className={styles.graphic_label}>
        Digital Maturity Assessment
      </Text>
    </div>
  );
}

/** Houses the rank in text format and the CTA */
function ScoreRank(props) {
  const { handleModal, rankingText } = props;
  return (
    <div className={styles.rank}>
      <div className={styles.rank_wrapper}>
        <Text
          weight="medium"
          className={styles.rank_overline}
          variant="overline"
        >
          Your digital score
        </Text>
        <Text weight="bold" className={styles.rank_label} variant="h3">
          {rankingText}
        </Text>
      </div>
      <Button onClick={handleModal}>Get a full report</Button>
    </div>
  );
}

export default ScoreContainer;
